// src/components/ChatHistory.jsx

import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";

const ChatHistory = () => {
  const location = useLocation();
  const { setSessionTimeout, setAlert, setMessage } = useContext(languageContext);
  const [messages, setMessages] = useState([]);

  const chat_history_patient = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_chat_history",
        JSON.stringify({ id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setMessages(response.data.chat_history);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        console.error("Error Details:", error.message);
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };

  useEffect(() => {
    chat_history_patient();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-r from-green-50 to-emerald-100">
      <Navbar />

      <div className="flex-grow pt-20 px-4 sm:px-8 overflow-auto">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-emerald-900 text-center mb-8 mt-6 sm:mt-10">
            🗨️ Nurse Dashboard – Patient Chat History
          </h2>

          {messages.length === 0 ? (
            <div className="text-center text-gray-500 italic py-20">
              No messages found.
            </div>
          ) : (
            <div className="space-y-6">
              {messages.map((msg) => (
                <div
                  key={msg.id}
                  className="bg-white rounded-xl border border-emerald-200 shadow-sm p-5 hover:shadow-md transition duration-200"
                >
                  <div className="flex justify-between text-xs text-gray-500 mb-2">
                    <span>{new Date(msg.timestamp).toLocaleString()}</span>
                    <span className="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full font-medium">
                      ID: {msg.id}
                    </span>
                  </div>

                  <div className="mb-2">
                    <p className="text-sm sm:text-base">
                      <span className="font-semibold text-emerald-700">Patient:</span>{" "}
                      {msg.user_question || (
                        <em className="text-gray-400">[No Question]</em>
                      )}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm sm:text-base">
                      <span className="font-semibold text-green-700">Assistant:</span>{" "}
                      {msg.bot_response || (
                        <em className="text-gray-400">[No Response]</em>
                      )}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHistory;
